import BuilderModel from "./builderModel";
import ProcessFlow from "~/models/processFlows/processFlow";
import IterationStep from "~/models/processFlows/steps/iterationStep";

export default class ProcessFlowBuilderModel extends BuilderModel {
  rootModel: ProcessFlow | IterationStep;
  flow: ProcessFlow;
  except = ['flow', 'createEmbeddedObject'];

  get processFlow(): ProcessFlow {
    return this.parent?.processFlow
  }
}
